import { en } from 'localization';
import { toast } from 'react-toastify';
import { ErrorCodeEnum, ErrorResponse } from 'types/error';
const { errorMessages } = en;

function getErrorMessage(
  errorCode: ErrorCodeEnum,
  field: string,
  value?: string
): string {
  const errorMessage =
    errorMessages[errorCode]?.[field] ?? errorMessages[errorCode]?.default;
  return value ? errorMessage.replace(/{\w+}/g, value) : errorMessage;
}

export function showErrorToast(error: ErrorResponse): void {
  const genericError = errorMessages.GenericError.default;
  const errorMessagesList: string[] = [];

  if (!error.errorCode && !error.arguments && !error.message) {
    errorMessagesList.push(genericError);
  } else if (error.arguments && Object.keys(error.arguments).length > 0) {
    for (const [field, value] of Object.entries(error.arguments)) {
      const localizedMessage = getErrorMessage(error.errorCode, field, value);
      errorMessagesList.push(localizedMessage);
    }
  } else if (error.errorCode) {
    errorMessagesList.push(getErrorMessage(error.errorCode, 'default'));
  } else {
    errorMessagesList.push(error.message || genericError);
  }

  const formattedMessage = errorMessagesList.join('\n');

  toast.error(formattedMessage, {
    style: { whiteSpace: 'pre-line' },
  });
}
